<div class="d-flex" id="wrapper">
  <div class="" id="sidebar-wrapper">
    <div class="sidebar-wrapper-bloc">
      <nav>
        <div class="sidebar-heading p-3 position-relative">
          <a href="#">
            <img class="img-fluid navbar-brand" src="assets/img/efb_white.svg" alt="logo.svg" width="120">
          </a>
          <!--  <div class="d-flex align-items-center">
             <div class="me-2">
               <div class="rounded-circle p-2 bg-dark text-white border style_slidebar_profil d-flex justify-content-center form-control align-items-center">
                 <small class="style_bord mb-0">AM</small>
               </div>
             </div>
             <div class="my-0 text-wrap">
               <h6 class="mb-0">
                 <a href="#">Assuris Mondji</a>
               </h6>
                 <p class="my-0 style_font_size_small text-white-50">Designer</p>
             </div>
           </div> -->
        </div>

        <ul class="m-0 p-3">
          <div class="mb-3">
            <small class="text-white-50">Menu</small>
          </div>

          <li class="nav-item">
            <a href="statistique.html" class="d-flex">
              <i class="bi-house me-2"></i>
              <span>Accueil</span>
            </a>
          </li>

          <!-- <li class="style_dropdown_wrapper">
            <a href="#" class="style_dropdown_toggle" onclick='this.parentElement.classList.toggle("style_toggled");'>
              <div class="d-flex justify-content-between flex-nowrap align-items-center">
                <div><i class="bi-egg-fried me-2"></i>Dropdown</div><i class="bi bi-caret-down-fill"></i>
              </div>
            </a>
            <ul class="">
                      <li class="">
                  <a href="/admin/plats/index/1" class="">Autres</a>
                </li>
                      <li class="">
                  <a href="/admin/plats/index/2" class="">Française</a>
                </li>
                <li class="">
                  <a href="/admin/plats/index/1" class="">Autres</a>
                </li>
                      <li class="">
                  <a href="/admin/plats/index/2" class="">Française</a>
                </li>
                <li class="">
                  <a href="/admin/plats/index/1" class="">Autres</a>
                </li>
                      <li class="">
                  <a href="/admin/plats/index/2" class="">Française</a>
                </li>
                 </ul>
             </li> -->

          <li class="nav-item active">
            <a href="operation.html" class="d-flex">
              <i class="bi-envelope-at me-2"></i>
              <span>Logging SMS</span>
            </a>
          </li>
        </ul>

        <ul class="m-0 p-3">
          <div class="mb-3">
            <small class="text-white-50">Configuration</small>
          </div>

          <ul class="nav nav flex-nowrap" style="width:calc(100% - 1px); overflow-x: auto;">
            <li class="me-1 nav-item active">
              <a href="#" class="" title="Gestion des frais"><i class="bi bi-cash-coin"></i></a>
            </li>
            <li class="me-1 nav-item" title="Gestion des utilisateurs">
              <a href="#" class=""><i class="bi bi-people"></i></a>
            </li>
          </ul>
        </ul>

      </nav>
    </div>
  </div>

  <div id="page-content-wrapper">

    <!-- Modal -->
    <div class="modal fade" id="exampleModalDeconnexion" data-bs-backdrop="static" tabindex="-1"
         aria-labelledby="exampleModalInitialisationLabel" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0">
          <div class="modal-header border-0 pb-0 align-items-start">
            <h5 class="mb-0" id="exampleModalInitialisationLabel">Vous etes sur le point de vous déconnecter</h5>
            <button type="button" class="btn-close ms-md-5" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body ">
            <div class="h-100 py-4 bg-light text-center p-3 rounded-3 d-flex flex-column align-items-center text-dark">
              <h1 class="mb-1 display-3"><i class="bi-door-open"></i></h1>
            </div>
          </div>
          <div class="modal-footer border-0 pt-0">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><i class="bi-x me-1"></i>Non
            </button>
            <a href="connexion.html" type="button" class="btn btn-dark shadow-sm"><i class="bi-check me-1"></i>Oui</a>
          </div>
        </div>
      </div>
    </div>

    <nav class="navbar navbar-expand-lg navbar-light bg-white py-1 px-lg-4 px-sm-3 px-2"
         style='z-index:1000; position: sticky; top: 0;'>
      <div class="container">
        <button class="text-dark bg-transparent border-0 me-3 p-0" type="button" id="menu-toggle">
          <svg width="20" height="16" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.75 0H23.25V2.5H0.75V0ZM0.75 8.75H15.75V11.25H0.75V8.75ZM0.75 17.5H23.25V20H0.75V17.5Z"
                  fill="#7A8599"/>
          </svg>
        </button>
        <div
          class="me-lg-3 rounded-circle p-2 bg-white text-dark border border-dark style_slidebar_profil d-flex justify-content-center form-control align-items-center">
          <small class="style_bord mb-0">AM</small>
        </div>

        <button class="navbar-toggle d-lg-none border-0 bg-transparent" type="button" data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
                aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <form class="d-flex flex-fill" role="search">
            <input list="propriétaire" (keyup)="onSearch($event)" placeholder="Rechercher dans les audits" [formControl]="searchControl" [(ngModel)]="search" type="text" class="form-control me-2">
            <datalist id="propriétaire">
              <option value="Meteor">
              <option value="Pils">
              <option value="Kronenbourg">
              <option value="Grimbergen">
            </datalist>
            <button class="btn btn-dark" type="submit"><i class="bi-search"></i></button>
          </form>

          <ul class="navbar-nav ms-auto mb-2 mb-lg-0 flex-fill justify-content-end">
            <li class="nav-item">
              <a href="#" class="nav-link" data-bs-toggle="modal" data-bs-target="#exampleModalDeconnexion"
                 type="button"><i class="bi bi-power"></i></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="page-content-wrapper-bloc p-lg-4 p-sm-3 p-2">
      <div class="container">
        <div class="d-flex">
          <div class="mb-3">
            <h4 class="mb-0">Listes des SMS</h4>
          </div>
        </div>
        <!--
                <div class="d-flex justify-content-end style_font_size_small mb-2">
                  <span class="ms-2 "><i class="bi-circle-fill me-1 text-dark"></i>30, En cours</span>
                  <span class="ms-2 "><i class="bi-circle-fill me-1 text-danger"></i>05, Erreurs</span>
                  <span class="ms-2 "><i class="bi-circle-fill me-1 text-success"></i>10, Terminée</span>
                </div> -->

        <div class="table-responsive">
          <table class="table align-middle">
            <thead class="">
            <tr class="text-nowrap bg-white">
              <td scope="col">Telephone</td>
              <td scope="col">Date</td>
              <td scope="col">Source / ID</td>
              <td scope="col">Contenus</td>
              <td scope="col">Status</td>
              <td scope="col"></td>
            </tr>
            </thead>
            <tbody>
            <tr class="text-nowrap bg-white" *ngFor="let sms of auditsPage?.content">
              <td>
                <span class="style_semiBold">{{sms?.receivedPhoneNumber}}</span>
              </td>
              <td>
                <span class="style_semiBold">{{sms?.createdDate | date: ' dd/MM/yyyy à HH:mm'}}</span>
              </td>
              <td>
                <span class="badge style_gradient border text-dark mb-1">{{sms?.provider}}</span>
                <small
                  class="d-block style_font_size_small">{{ sms?.transactionId ? sms?.transactionId : sms?.ussdSessionId }}</small>
              </td>
              <td>
                <p class="style_font_size_small text-wrap mb-0 text-secondary" [innerHTML]="linkify(sms?.contentSms)">
                  <!--                  {{ linkify(sms?.contentSms) }}-->
                  <!--     Numero unique parcellaire 100073342 est
                       enregistré au cadastre comme Parcelle avec proprietaire inconnu Plus d infos : <a href="#"
                                                                                                         class="text-primary">https://cadastre.andf.bj:8099/nup/100073342</a>
                    --> </p>
              </td>
              <td>
                <span *ngIf="sms?.sent" class="badge bg-success text-white">Success</span>
                <span *ngIf="!sms?.sent" class="badge bg-danger text-white">echec</span>
              </td>
              <td>
                <div class="d-flex justify-content-center">
                  <button [disabled]="isSent" class="btn btn-sm btn-primary" (click)="resentSms(sms?.transactionId ? sms?.transactionId : sms?.ussdSessionId)" ><i class="bi-send-fill me-2"></i>Renvoyer
                  </button>
                </div>
              </td>
            </tr>

            </tbody>
          </table>
        </div>


        <nav class="style_pagination">
          <ul class="pagination justify-content-end">
            <li (click)="changePage(auditsPage,'prev')" class="page-item" [ngClass]="auditsPage.first ? 'disabled': ''" >
              <a class="page-link style_page_link">«</a>
            </li>
            <li class="page-item active"><a class="page-link" >{{auditsPage?.pageable?.pageNumber + 1}}</a></li>
            <li class="page-item disabled"><a class="page-link style_page_link" >/</a></li>
            <li class="page-item"><a class="page-link" >{{auditsPage?.totalPages}}</a></li>
            <li class="page-item" [ngClass]="auditsPage.last ? 'disabled': ''">
              <a class="page-link style_page_link" (click)="changePage(auditsPage,'next')">»</a>
            </li>
          </ul>
        </nav>
      </div>

    </div>

    <div class="px-lg-4 px-sm-3 px-2">
      <div class="container py-2">
        <small class="m-0">Copyright © 2022 <a class="text-primary style_link" href="#">ANDF</a>. Développée par <a
          class="text-primary style_link" href="#">PMAF</a> touts droits réservés.</small>
      </div>
    </div>
  </div>

</div>
